export default __webpack_public_path__ + "static/media/product11.467163bd.jpg";